import Debug from "debug";
const debug = Debug("broadcast:utils:regionUtils");

export const getRegionFromParentUrl = (): string => {
  const parentUrl = document.referrer;

  debug(document.referrer);
  if (/http:\/\/localhost.*/.test("" + parentUrl)) {
    debug("Running locally setting region to eu");
    return "eu";
  }

  if (/https:\/\/.*\.eu\..*/.test("" + parentUrl)) {
    return "eu";
  } else {
    return "us";
  }
};
